<template>
  <form v-on:submit.prevent="submitForm()" novalidate>
    <!-- имя -->
    <div class="my-1">
      <div class="input-group">
        <div class="input-group-text"><font-awesome-icon icon="fa-solid fa-user" /></div>
        <input type="text" class="form-control" placeholder="имя, фамилия" name="fullname" v-model="form.fullname" />
      </div>
      <div data-error class="alert alert-danger my-1 px-2 py-1" role="alert">{{ errors.form.fullname }}</div>
    </div>

    <p class="mt-3">Основной номер телефона <small class="text-muted">(на него приходят смс)</small></p>

    <!-- тел -->
    <div class="my-1">
      <div class="input-group">
        <div class="input-group-text"><font-awesome-icon icon="fa-solid fa-phone" /></div>
        <select
          v-model="objProfile.country.phone"
          class="form-select form-select__country"
          title="Формат номера телефона">
          <option v-for="el in countrieslist" :key="el.value" :value="el.value">
            {{ el.text }}
          </option>
        </select>
        <input
          v-maska="objProfile.phone"
          :data-maska="objProfile.mask.phone"
          type="tel"
          name="phone"
          v-model="form.phone"
          @maska="onMaskaProfilePhone"
          class="form-control maska-phone"
          :class="{
            'is-invalid': !objProfile.phone.completed,
            'is-valid': objProfile.phone.completed,
          }"
          :placeholder="objProfile.mask.phone.replaceAll('#', 'x')" />
      </div>
      <div data-error class="alert alert-danger my-1 px-2 py-1" role="alert">{{ errors.form.phone }}</div>
    </div>

    <p class="mt-3">Дополнительные способы связи</p>

    <!-- тел. второй -->
    <div class="my-1">
      <div class="input-group">
        <div class="input-group-text"><font-awesome-icon icon="fa-solid fa-phone" /></div>
        <select
          v-model="objProfile.country.mobilephone"
          class="form-select form-select__country"
          title="Формат номера телефона">
          <option v-for="el in countrieslist" :key="el.value" :value="el.value">
            {{ el.text }}
          </option>
        </select>
        <input
          v-maska="objProfile.mobilephone"
          :data-maska="objProfile.mask.mobilephone"
          type="tel"
          name="mobilephone"
          v-model="form.mobilephone"
          @maska="onMaskaProfileMobilephone"
          class="form-control maska-mobilephone"
          :class="{
            'border border-warning': objProfile.mobilephone.unmasked != '' && objProfile.mobilephone.completed == false,
            'bg-warning bg-opacity-25':
              objProfile.mobilephone.unmasked != '' && objProfile.mobilephone.completed == false,
            'border border-success': objProfile.mobilephone.completed == true,
            'bg-success bg-opacity-25': objProfile.mobilephone.completed == true,
          }"
          :placeholder="objProfile.mask.mobilephone.replaceAll('#', 'x')" />
      </div>
      <div data-error class="alert alert-danger my-1 px-2 py-1" role="alert">{{ errors.form.mobilephone }}</div>
    </div>

    <!-- email -->
    <div class="my-1">
      <div class="input-group">
        <div class="input-group-text"><font-awesome-icon icon="fa-solid fa-at" /></div>
        <input type="email" class="form-control" placeholder="адрес эл. почты" name="email" v-model="form.email" />
      </div>
      <div data-error class="alert alert-danger my-1 px-2 py-1" role="alert">{{ errors.form.email }}</div>
    </div>

    <p class="mt-3">Адрес доставки</p>

    <!-- адрес -->
    <div class="my-1">
      <div class="input-group">
        <div class="input-group-text"><font-awesome-icon icon="fa-solid fa-map-marker-alt" /></div>
        <VueSuggestions
          :model.sync="form.client_address"
          :coordinates.sync="form.coordinates"
          :placeholder="'Начните вводить'"
          class="form-control"
          :options="suggestionOptions">
        </VueSuggestions>
      </div>
      <div data-error class="alert alert-danger my-1 px-2 py-1" role="alert">{{ errors.form.client_address }}</div>
    </div>

    <div data-error class="alert alert-info mb-1 mt-3 px-2 py-1" role="alert">{{ errors.form.common }}</div>

    <div class="my-1 mt-2">
      <button type="submit" class="btn btn-primary" :disabled="isLoading">
        <font-awesome-icon icon="fa-solid fa-check"></font-awesome-icon> Сохранить
      </button>
    </div>
  </form>
</template>

<script>
import axios from 'axios';

import { vMaska } from 'maska';
import { countries } from '@/constants/countries';
// , defaultFormat

import VueSuggestions from 'vue-suggestions';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faUser, faPhone, faAt, faCity, faMapMarkerAlt, faCheck, faKey } from '@fortawesome/free-solid-svg-icons';
library.add(faUser, faPhone, faAt, faCity, faMapMarkerAlt, faCheck, faKey);

export default {
  directives: { maska: vMaska },
  data: function () {
    return {
      isLoading: false,
      //
      form: {
        _token: this.csrf,
        id: parseInt(this.id),
        fullname: this.fullname,
        email: this.email,
        phone: this.phone,
        mobilephone: this.mobilephone,
        client_address: this.client_address,
        coordinates: {
          latitude: '',
          longitude: '',
        },
      },
      errors: {
        form: {
          fullname: '',
          email: '',
          phone: '',
          mobilephone: '',
          client_address: '',
          coordinates: '',
          //
          common: '',
        },
      },
      // maska:
      countrieslist: { ...countries },
      objProfile: {
        phone: {
          completed: false,
          masked: '',
          unmasked: '',
        },
        mobilephone: {
          completed: false,
          masked: '',
          unmasked: '',
        },
        raw: {
          phone: '',
          mobilephone: '',
        },
        country: {
          phone: '7',
          mobilephone: '7',
        },
        mask: {
          phone: '+7 (###) ###-##-##',
          mobilephone: '+7 (###) ###-##-##',
        },
      },
      // datata token
      token: process.env.VUE_APP_DADATA_API_KEY,
      // dadata
      suggestionOptions: {
        // @see https://confluence.hflabs.ru/pages/viewpage.action?pageId=207454318
        token: process.env.VUE_APP_DADATA_API_KEY,
        type: 'ADDRESS',
        scrollOnFocus: false,
        triggerSelectOnBlur: false,
        triggerSelectOnEnter: false,
        addon: 'none',
        // @see https://confluence.hflabs.ru/pages/viewpage.action?pageId=207454320
        //onSelect(suggestion) { /* */ },
      },
    };
  },
  props: {
    csrf: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    fullname: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    phone: {
      type: String,
      default: '',
    },
    mobilephone: {
      type: String,
      default: '',
    },
    client_address: {
      type: String,
      default: '',
    },
  },
  components: {
    VueSuggestions,
    FontAwesomeIcon,
  },
  methods: {
    submitForm() {
      // убрать старые ошибки
      Object.keys(this.errors.form).forEach((key) => {
        this.errors.form[key] = '';
      });

      let withErrors = false;

      // проверки
      if (this.form.phone === '') {
        this.errors.form.phone = 'Нужно ввести номер телефона.';
        withErrors = true;
      }
      // проверки
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (this.form.email !== '' && emailPattern.test(this.form.email) == false) {
        this.errors.form.email = 'Некорректный адрес эл. почты.';
        withErrors = true;
      }

      if (withErrors) {
        return false;
      }

      this.isLoading = true;
      this.errors.form.common = 'Сохранение профиля...';

      axios
        .put(`/backend/profile/edit/${this.form.id}`, this.form)
        .then((res) => {
          if (res.data.status == 'ok') {
            this.errors.form.common = 'Успешно сохранено!';
          }
          if (res.data.status == 'error') {
            const errors = res.data.errors || {};
            const fieldErrors = errors.validation || {};
            const customErrors = errors.customErrors || {};
            const commonErrors = errors.common || [];

            Object.keys(fieldErrors).forEach((key) => {
              this.errors.form[key] = fieldErrors[key].join(' ');
            });

            Object.keys(customErrors).forEach((key) => {
              this.errors.form[key] = customErrors[key].join(' ');
            });

            this.errors.form.common = commonErrors.join(' ');
          }
        })
        .catch((err) => {
          this.errors.form.common = 'Ошибка на сервере, обновите страницу и попробуйте ещё раз.';
          console.error(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    //
    onMaskaProfilePhone(event) {
      this.objProfile.raw.phone = event.detail.unmasked;
    },
    onMaskaProfileMobilephone(event) {
      this.objProfile.raw.mobilephone = event.detail.unmasked;
    },
  },
  watch: {
    'objProfile.country.phone': {
      // eslint-disable-next-line
      handler(newVal) {
        this.objProfile.mask.phone = countries.filter((el) => el.value == newVal)[0].mask;
        this.form.phone = this.objProfile.raw.phone;
      },
    },
    'objProfile.country.mobilephone': {
      // eslint-disable-next-line
      handler(newVal) {
        this.objProfile.mask.mobilephone = countries.filter((el) => el.value == newVal)[0].mask;
        this.form.mobilephone = this.objProfile.raw.mobilephone;
      },
    },
  },
};
</script>

<style lang="scss">
.form-select__country {
  max-width: 85px;
}
</style>
